import type {RouteObject} from 'react-router';

let reactRoutePaths: string[] = [];

const normalizePath = (path: string): string => {
    if (!path.startsWith('/')) {
        return `/${path}`;
    }

    return path;
};

const joinPaths = (parentPath: string, childPath: string): string => {
    if (!childPath) {
        return parentPath || '/';
    }

    if (childPath.startsWith('/')) {
        return childPath;
    }

    const basePath = parentPath === '/' ? '' : parentPath;
    return `${basePath}/${childPath}`.replace(/\/{2,}/g, '/');
};

const collectPaths = (
    routes: RouteObject[],
    parentPath: string,
    accumulator: Set<string>
): void => {
    routes.forEach(route => {
        const routePath = route.path ?? '';
        const fullPath = normalizePath(joinPaths(parentPath, routePath));
        const nextParentPath = routePath ? fullPath : parentPath;

        if (routePath && routePath !== '*') {
            accumulator.add(fullPath);
        }

        if (route.children) {
            collectPaths(route.children, nextParentPath, accumulator);
        }
    });
};

export const extractReactRoutePaths = (routes: RouteObject[]): string[] => {
    const pathSet = new Set<string>();
    collectPaths(routes, '', pathSet);
    return Array.from(pathSet).sort((a, b) => a.localeCompare(b));
};

export const setReactRoutePaths = (paths: string[]): void => {
    reactRoutePaths = [...paths];
};

export const getReactRoutePaths = (): string[] => {
    return reactRoutePaths;
};
